import { app } from '../../../../../app';
import { Controller } from './what-is-sms-service.controller';

app.component('companySmsServicesHelpWhatIsSmsService', {
    controller: Controller,
    templateUrl: require('./what-is-sms-service.html'),
});



// WEBPACK FOOTER //
// ./src/portal/states/company/sms-services/help/what-is-sms-service/what-is-sms-service.component.js